<template>
  <div class="wrap-vacancy">
    <div class="vac-card flex flex-col" position_rate="1">
      <div>
        <b-button
          v-if="item.status == 'SEEN' || item.status == 'SEND_DOCUMENT'"
          style="font-size: 12px; min-width: 120px; border-radius: 8px"
          @click="$emit('returnDoc', item)"
          size="sm"
          class="mt-2 float-right"
          variant="outline-danger"
        >
          <span class="fa fa-times"></span>
          {{ $t("returnDocument") }}
        </b-button>
      </div>
      <div class="vac-card__item">
        <div href="javascript:void(0)" class="flex justify-between">
          <h5 class="vac-card__title">
            <span>
              {{ item[$localeKey("staffPositionName")] }}
            </span>
          </h5>
        </div>
        <p class="vac-card__unit">
          <span>
            {{ item[$localeKey("typePositionName")] }}
          </span>
        </p>
      </div>
      <div class="vac-card__item">
        <p class="vac-card__location">
          <i class="fa fa-building"> </i>
          {{ item[$localeKey("departmentName")] }}
        </p>
        <p class="vac-card__location">
          <i class="fa fa-user"> </i>
          <span style="text-transform: lowercase">
            {{ $t("home.vacancy") }} : {{ item.vacancy }}
          </span>
        </p>
        <p class="vac-card__location">
          <i class="fa fa-book"> </i>
          <b-button
            @click="$emit('startTest', item)"
            v-if="item.status === 'TEST' || item.status == 'TEST_PROCESS'"
            variant="outline-primary"
            class="p-1"
            style="font-size: 13px; width: 120px"
            >{{ $t(`status.${item.status}`) }}</b-button
          >
          <b-badge
            v-else
            :variant="
              item.status == 'DELETED' || item.status == 'FAILED_TEST'
                ? 'danger'
                : 'primary'
            "
            class=""
            >{{ $t(`status.${item.status}`) }}</b-badge
          >
        </p>
      </div>
      <div v-b-toggle="'accordion-' + item.id" class="more-show">
        <span> {{ $t("statusAriza") }} </span>
        <i class="fa fa-chevron-down"></i>
      </div>
      <b-collapse
        @show="$emit('show', item)"
        accordion="my-accordion"
        class="pb-2"
        role="tabpanel"
        :id="`accordion-${item.id}`"
      >
        <div class="card">
          <div class="card-body">
            <div>
              <ul class="verti-timeline list-unstyled">
                <li
                  class="event-list"
                  v-for="(item, index) in collapseItems"
                  :key="index"
                >
                  <div class="event-timeline-dot">
                    <i class="fas fa-arrow-circle-right"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <img
                        width="30"
                        :src="
                          item.status == 'SEND_DOCUMENT'
                            ? require('@/assets/sendDoc.png')
                            : item.status == 'SEEN'
                            ? require('@/assets/seen.png')
                            : item.status == 'TEST'
                            ? require('@/assets/test.png')
                            : item.status == 'TEST_PROCESS'
                            ? require('@/assets/test-start.png')
                            : item.status == 'PASSED_TEST'
                            ? require('@/assets/passed.png')
                            : item.status == 'FAILED_TEST'
                            ? require('@/assets/failed-test.png')
                            : item.status == 'MEETING'
                            ? require('@/assets/meeting.png')
                            : item.status == 'PASSED_MEETING'
                            ? require('@/assets/passed-meeting.png')
                            : item.status == 'FAILED_MEETING'
                            ? require('@/assets/failed-meeting.png')
                            : item.status == 'CONTRACT'
                            ? require('@/assets/contract.png')
                            : item.status == 'DELETED'
                            ? require('@/assets/file-return.webp')
                            : ''
                        "
                      />
                    </div>
                    <div class="media-body">
                      <div>
                        <h5 class="font-size-14">
                          {{ $t(`status.${item.status}`) }}
                        </h5>
                        <p class="text-muted">{{ item.reason }}</p>
                        <p v-if="item.status == 'DELETED'" class="text-muted">
                          {{ $t("returned") }} : {{ item.date }}
                        </p>
                        <b-button
                          v-if="item.status == 'NOT_ACCEPTED'"
                          variant="primary"
                          @click="viewAnswerDoc(item)"
                          class="only-desctop"
                        >
                          {{ $t("answerDoc") }}
                          <i class="fa fa-eye"></i>
                        </b-button>
                        <b-overlay
                          :show="loading && item.id == current.id"
                          variant="transparent"
                        >
                          <b-button
                            v-if="item.status == 'NOT_ACCEPTED'"
                            variant="primary"
                            @click="downloadAnswerDoc(item)"
                            class="only-mobile"
                          >
                            {{ $t("answerDoc") }}
                            <i class="fa fa-download"></i>
                          </b-button>
                        </b-overlay>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <ViewPdf ref="viewPdf" />
  </div>
</template>

<script>
import ViewPdf from "@/components/ViewPdf";
import Service from "@/services/vacancy.service";

export default {
  components: {
    ViewPdf,
  },
  props: {
    collapseItems: {
      default: () => [],
    },
    item: {
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      current: {},
    };
  },
  methods: {
    async viewAnswerDoc(item) {
      this.$refs.viewPdf.show();
      let res = await Service.getAnswerDoc({
        employeeId: item.employeeId,
        staffListVacancyId: item.hrStaffListVacancyId,
      });
      this.$refs.viewPdf.viewPdfArg(this.$answerDocHtml(res.data));
    },
    async downloadAnswerDoc(item) {
      this.current = item;
      this.loading = true;
      try {
        let res = await Service.getAnswerDoc({
          employeeId: item.employeeId,
          staffListVacancyId: item.hrStaffListVacancyId,
        });
        await this.$refs.viewPdf.downloadPdf(this.$answerDocHtml(res.data));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 500px) {
  .only-desctop {
    display: none;
  }
}
@media (min-width: 500px) {
  .only-mobile {
    display: none;
  }
}
.wrap-vacancy {
  .more-show {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    padding: 15px 0;
  }
  .more-show i {
    margin-left: 5px;
  }

  .vac-card {
    padding: 0 24px;
    padding-bottom: 0;
    background: #fcfcfe;
    border: 1px solid #a0baee;
    border-radius: 12px;
    transition: 0.3s ease-in-out;
    margin-bottom: 30px;
    color: #007bff;
  }
  .vac-card:hover {
    text-decoration: none;
  }
  .vac-card__location {
    margin-bottom: 7px;
  }
  .vac-card__location i {
    margin-right: 4px;
  }
  .flex-col {
    flex-direction: column;
  }
  .md\:flex-row {
    flex-direction: row;
  }
  .flex {
    display: flex;
  }
  .vac-card__item {
    padding: 20px 0;
    border-bottom: 1px solid #a0baee;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .justify-between {
    justify-content: space-between;
  }
  .vac-card__unit {
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    color: #3165cb;
  }
  .vac-card__title {
    color: #000;
  }
  .md\:items-center {
    align-items: center;
  }
  .md\:flex-row {
    flex-direction: row;
  }
  .pb-\[20px\] {
    padding-bottom: 20px;
  }
  .pt-\[16px\] {
    padding-top: 16px;
  }
  .justify-between {
    justify-content: space-between;
  }
}
</style>